import React, { useState } from 'react';
import { Inventory, InventoryItem, Variation, VariationItem } from '../../../@types/inventory';
import { InventoryTable } from './InventoryTable';
import { VariationDropdownForm } from './VariationForm';

interface InventoryLineProps {
  inventory: InventoryItem;
  setInventories: any;
  variations: VariationItem[];
  setVariations: (Variations: VariationItem[]) => void;
  error: any;
  variationList: any;
}

const InventoryLine = ({
  inventory,
  setInventories,
  variations,
  setVariations,
error,
  variationList,
}: InventoryLineProps) => {
  const [showVariationForm, setShowVariationForm] = useState(false);

  return (
    <div>
      <InventoryTable
        inventory={inventory}
        setInventories={setInventories}
        variations={variations}
        setVariations={setVariations}
        error={error}
        variationList={variationList}
      />

      <div className="">
        {showVariationForm && <VariationDropdownForm key={inventory.name} variations={inventory.variations} />}
      </div>
    </div>
  );
};

export { InventoryLine };
